class BasePlugin {
  // 插件名称对应原生配置插件名称
  constructor (pluginName) {
    this.pluginName = pluginName
  }

  // methodName原生方法名
  execNativeMethod (methodName, args = []) {
    const exec = window.cordova.require('cordova/exec')
    return new Promise((resolve, reject) => {
      exec(
        (...args) => {
          resolve(...args)
        },
        e => {
          reject(e)
        },
        this.pluginName,
        methodName,
        args
      )
    })
  }
}

class Share extends BasePlugin {
  share (content) {
    return this.execNativeMethod('share', [content])
  }
}

class App extends BasePlugin {
  // 退出webView
  finish () {
    return this.execNativeMethod('finish')
  }
  back () {
    return this.execNativeMethod('back')
  }
  // 打开新的窗口
  openNewWindow (url) {
    return this.execNativeMethod('openNewWindow', [{ url }])
  }
  openUrl (url) {
    return this.execNativeMethod('openUrl', [url])
  }
  // 检查网络状态  -1未知网络链接    0无网络  1 wifi   2 移动网络
  networkState () {
    return this.execNativeMethod('networkState', [])
  }
}

class Message extends BasePlugin {
  goToChat (userName, name) {
    return this.execNativeMethod('goToChat', [{ userName, name }])
  }
}

class User extends BasePlugin {
  getUser () {
    return this.execNativeMethod('getUser', []).then(user => {
      return User.normalize(user)
    })
  }
  static normalize (user) {
    const userID = parseInt(user.userID || user.userId)
    const role = parseInt(user.role || user.roleId)
    const token = user.token || user.authorization
    const avatar = user.avatar || user.headimage
    let sex = 0
    switch (user.sex) {
      case '1':
      case 1:
      case true:
        sex = 1 // 男
        break
      case '2':
      case 2:
      case false:
        sex = 0 // 女
        break
    }
    return { ...user, userID, role, sex, token, avatar }
  }
}

export const app = new App('UApp')
export const share = new Share('UShare')
export const message = new Message('UMessage')
export const user = new User('User')
